import React, { useEffect, useState } from "react";
import "./GuideView.css";
import {
  Box,
  Typography,
  Button,
  Stack,
  Tabs,
  Tab,
  Dialog,
  IconButton,
} from "@mui/material";
import PageContainer from "../../components/container/PageContainer";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import radarImage from "../../assets/radarImage.svg";
import locationDarkImage from "../../assets/locationDarkImage.svg";
import CustomTimeline from "../../components/shared/CustomTimeline";
import { getGuides } from "../../services/guides";
import {
  DARCKBACKGROUND,
  DARCKCOLOR,
  DARCKOPACITYBACKGROUND8,
  DARCKOPACITYCOLOR6,
  DARCKOPACITYCOLOR8,
  languageMap,
  TYPEIMAGE,
  TYPEVIDEO,
} from "../../helpers/Config";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import PreloaderCustom from "../../components/shared/PreloaderCustom";
import ReactPlayer from "react-player";
import CustomCarousel from "../../components/shared/CustomCarousel";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import routingImageDark from "../../assets/routingImageDark.svg";
import {
  sxColumnStart,
  sxColumnStartEnd,
  sxRowCenter,
  sxRowCenterBetween,
  sxRowCenterStart,
  sxRowStartBetween,
  sxText1240016,
  sxText1250016,
  sxText1440020,
  sxText1450020,
  sxText1860028,
} from "../../theme/sxStyle";

const sxImgStyles = {
  objectFit: "cover",
  borderRadius: "24px",
  cursor: "pointer",
  width: "138px",
  minWidth: "138px",
  height: "130px",
  "@media (min-width: 768px)": {
    width: "200px",
    minWidth: "200px",
    height: "180px",
  },
};

function GuideView() {
  const [guides, setGuides] = useState({});
  const [value, setValue] = useState(0);
  const [isPreloader, setIsPreloader] = useState(true);
  const [isOpenViewMedia, setIsOpenViewMedia] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const { guideId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (guideId?.length) {
      const fetchData = async () => {
        if (guideId?.length) {
          let res = await getGuides(guideId, dispatch);
          console.log("res", res);
          if (res?.id?.length) {
            setGuides(res);
          }
        }
        setIsPreloader(false);
      };
      fetchData();
    }
  }, [guideId]);

  const handleCloseViewMedia = () => {
    setIsOpenViewMedia(false);
  };

  const handleOlenViewMedia = (index) => {
    setSelectedImageIndex(index);
    setIsOpenViewMedia(true);
  };

  return (
    <PageContainer
      title={"Home"}
      description={"this is HomeView"}
      keywords={"Home"}
    >
      {isPreloader && <PreloaderCustom />}
      <Box
        flex={1}
        position={"relative"}
        width={"100%"}
        mx={"auto"}
        pt={1}
        sx={{
          ...sxColumnStartEnd,
          "@media (min-width: 768px)": {
            maxWidth: "1000px",
          },
        }}
      >
        {!!guides?.media?.length ? (
          <Box position={"relative"}>
            <Box
              sx={{
                position: "fixed",
                top: "-88px",
                left: "50%",
                width: "100%",
                height: "450px",
                zIndex: 2,
                background: `linear-gradient(to bottom, rgba(33, 37, 41, 0.2), ${DARCKOPACITYBACKGROUND8})`,
                transform: "translateX(-50%)",
                "@media (min-width: 600px)": {
                  width: "calc(100vw - 48px)",
                  maxWidth: "1000px",
                },
                "@media (min-width: 768px)": {
                  width: "calc(100vw - 48px)",
                  maxWidth: "1000px",
                },
              }}
            />
            {!!guides?.media?.find(
              (item) => item?.primary === true && item?.type === TYPEIMAGE
            )?.id?.length ? (
              <Box
                component={"img"}
                alt="img"
                src={
                  guides?.media?.filter((item) => item?.type === TYPEIMAGE)[0]
                    ?.url
                }
                width={"100%"}
                height={"auto"}
                maxHeight={"450px"}
                minHeight={"320px"}
                position={"fixed"}
                top={"-88px"}
                left={"50%"}
                zIndex={1}
                sx={{
                  transform: "translateX(-50%)",
                  borderRadius: "0",
                  objectFit: "cover",
                  objectPosition: "top",
                  background: `linear-gradient(to bottom, rgba(33, 37, 41, 0), ${DARCKOPACITYBACKGROUND8})`,
                  "@media (min-width: 600px)": {
                    width: "calc(100vw - 48px)",
                    maxWidth: "1000px",
                  },
                  "@media (min-width: 768px)": {
                    width: "calc(100vw - 48px)",
                    maxWidth: "1000px",
                  },
                }}
              />
            ) : (
              <ReactPlayer
                url={
                  guides?.media?.find(
                    (item) => item?.primary === true && item?.type === TYPEVIDEO
                  )?.url
                }
                playing={true}
                loop={true}
                muted={true}
                config={{
                  file: {
                    attributes: {
                      // crossOrigin: 'anonymous',
                      poster: guides?.media?.find(
                        (item) =>
                          item?.primary === true && item?.type === TYPEVIDEO
                      )?.preview,
                    },
                    forceVideo: true,
                  },
                }}
                className="guide-view__video"
              />
            )}
          </Box>
        ) : (
          <Box
            width={"100%"}
            height={"400px"}
            position={"fixed"}
            top={"0"}
            left={"50%"}
            zIndex={1}
            sx={{
              ...sxRowCenter,
              borderRadius: "0",
              objectFit: "cover",
              backgroundColor: "#9a9da1",
              transform: "translateX(-50%)",
              "@media (min-width: 600px)": {
                width: "calc(100vw - 48px)",
                maxWidth: "1000px",
              },
              "@media (min-width: 768px)": {
                maxWidth: "1000px",
              },
            }}
          >
            <NoPhotographyIcon
              sx={{
                width: "100px",
                height: "auto",
                transform: "translateY(-70px)",
                color: "rgba(245, 246, 247, 1)",
                fill: "rgb(30 30 31)",
              }}
            />
          </Box>
        )}
        <Box
          position={"relative"}
          flex={1}
          width={"100%"}
          maxHeight={"calc(100vh - 88px)"}
          minHeight={"calc(100vh - 88px)"}
          display={"flex"}
          flexDirection={"column"}
          backgroundColor="transparent"
          borderRadius="30px 30px 0 0 !important"
          justifySelf={"flex-end"}
          overflow={"auto"}
          zIndex={2}
          sx={{
            "&::-webkit-scrollbar": {
              width: "0",
              height: "0",
            },
          }}
        >
          <Box
            position={"relative"}
            flex={1}
            width={"100%"}
            display={"flex"}
            flexDirection={"column"}
            borderRadius="30px 30px 0 0 !important"
            p={"0"}
            mt={"110px"}
            justifySelf={"flex-end"}
            zIndex={2}
            sx={{
              "&::-webkit-scrollbar": {
                width: "0",
                height: "0",
              },
            }}
          >
            <Box
              position={"sticky"}
              top={0}
              left={0}
              width={"100%"}
              height={"24px"}
              minHeight={"24px"}
              borderRadius="30px 30px 0 0 !important"
              backgroundColor={"rgba(245, 246, 247, 1)"}
              zIndex={3}
            />
            <Box
              p={"0 16px"}
              backgroundColor="rgba(245, 246, 247, 1)"
              borderRadius={0}
            >
              <Stack gap={1} sx={sxRowStartBetween}>
                <Typography variant="h4" color={DARCKCOLOR} sx={sxText1860028}>
                  {guides?.name}
                </Typography>
                <Box
                  component="img"
                  src={radarImage}
                  alt="img"
                  sx={{
                    width: "20px",
                    height: "20px",
                  }}
                />
              </Stack>
              <Stack gap={"4px"} mb={3} sx={sxRowCenterStart}>
                <Typography
                  variant="body1"
                  color={DARCKOPACITYCOLOR8}
                  sx={sxText1240016}
                >
                  Language
                </Typography>
                <Box
                  width={"4px"}
                  height={"4px"}
                  backgroundColor={"rgba(217, 217, 217, 1)"}
                />
                <Typography
                  variant="body1"
                  color={DARCKCOLOR}
                  sx={sxText1250016}
                >
                  {languageMap[guides?.language] || guides?.language}
                </Typography>
              </Stack>
              <Stack flexWrap={"wrap"} gap={4} mb={1.5} sx={sxRowCenterStart}>
                <Stack gap={1} sx={sxRowCenterStart}>
                  <Box
                    component="img"
                    src={locationDarkImage}
                    alt="img"
                    sx={{
                      width: "40px",
                      height: "40px",
                    }}
                  />
                  <Stack display={"flex"}>
                    <Typography
                      variant="body1"
                      color={DARCKOPACITYCOLOR8}
                      sx={sxText1240016}
                    >
                      Location
                    </Typography>
                    <Typography
                      variant="body1"
                      color={DARCKCOLOR}
                      sx={sxText1450020}
                    >
                      {guides?.location?.country}, {guides?.location?.city}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack gap={1} sx={sxRowCenterStart}>
                  <Box
                    component="img"
                    src={routingImageDark}
                    alt="img"
                    sx={{
                      width: "40px",
                      height: "40px",
                    }}
                  />
                  <Stack display={"flex"}>
                    <Typography
                      variant="body1"
                      color={DARCKOPACITYCOLOR8}
                      sx={sxText1240016}
                    >
                      Duration
                    </Typography>
                    <Typography
                      variant="body1"
                      color={DARCKCOLOR}
                      sx={sxText1450020}
                    >
                      {Math.floor(guides.duration / 3600) +
                        (guides.duration % 3600 === 0
                          ? " hours"
                          : ` hours ${Math.floor(
                              (guides.duration % 3600) / 60
                            )} min`)}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
              <Tabs
                value={value}
                onChange={(event, newValue) => setValue(newValue)}
                aria-label="basic tabs example"
                sx={{
                  width: "100%",
                  "& .MuiTabs-indicator": {
                    height: "1px",
                    backgroundColor: DARCKBACKGROUND,
                  },
                }}
              >
                <Tab
                  label="Overview"
                  sx={{
                    ...sxText1450020,
                    width: "50%",
                    maxWidth: "50%",
                    color: DARCKOPACITYCOLOR6,
                    "&.MuiButtonBase-root": {
                      borderBottom: "1px solid rgba(217, 217, 217, 1)",
                    },
                    "&.Mui-selected": {
                      color: DARCKCOLOR,
                      fontWeight: 500,
                    },
                  }}
                />
                <Tab
                  label="Details"
                  sx={{
                    ...sxText1450020,
                    width: "50%",
                    maxWidth: "50%",
                    color: DARCKOPACITYCOLOR6,
                    "&.MuiButtonBase-root": {
                      borderBottom: "1px solid rgba(217, 217, 217, 1)",
                    },
                    "&.Mui-selected": {
                      color: DARCKCOLOR,
                      fontWeight: 500,
                    },
                  }}
                />
              </Tabs>
            </Box>
            <Box
              pb={`calc(100px + env(safe-area-inset-bottom))`}
              backgroundColor="rgba(245, 246, 247, 1)"
              sx={{
                ...sxColumnStart,
                flex: 1,
                gap: "10px",
                borderRadius: "0",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {value === 1 && (
                <Box sx={sxColumnStart} p={"0 16px"}>
                  <CustomTimeline
                    deteails={guides?.details?.length ? guides?.details : []}
                  />
                </Box>
              )}
              {value === 0 && (
                <Box width={"100%"} sx={sxColumnStart}>
                  <Typography
                    variant="body1"
                    color={DARCKOPACITYCOLOR8}
                    p={"0 16px"}
                    mt={2}
                    sx={sxText1440020}
                  >
                    {guides?.description}
                  </Typography>
                  {isOpenViewMedia && !!guides?.media?.length && (
                    <Dialog
                      open={isOpenViewMedia}
                      onClose={handleCloseViewMedia}
                      sx={{
                        margin: "0 auto",
                        overflow: "hidden",
                        "& .MuiPaper-root": {
                          width: "95dvw",
                          height: "95dvh",
                          maxWidth: "100vw",
                          maxHeight: "100vh",
                          overflow: "visible",
                          margin: "0 auto",
                        },
                      }}
                    >
                      <CustomCarousel
                        media={guides?.media}
                        handleCloseViewMedia={handleCloseViewMedia}
                        initialSlide={selectedImageIndex}
                      />
                    </Dialog>
                  )}
                  <Typography
                    variant="h6"
                    color={DARCKCOLOR}
                    p={"0 16px"}
                    mt={3}
                    sx={sxText1450020}
                  >
                    Videos
                  </Typography>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    gap={1}
                    width={"100%"}
                    mt={2}
                    mb={2}
                    p={"0 16px"}
                    sx={{
                      overflow: "auto",
                      scrollbarWidth: "none",
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                    }}
                  >
                    {!!guides?.media?.length &&
                      guides.media.map((item, index) => {
                        const isVideo = item?.type !== TYPEIMAGE;
                        const src = isVideo ? item.preview : item.url;
                        return (
                          <Box
                            key={item.id || index}
                            position={isVideo ? "relative" : "static"}
                          >
                            <Box
                              component="img"
                              src={src}
                              alt="img"
                              sx={sxImgStyles}
                              onClick={() => handleOlenViewMedia(index)}
                            />
                            {isVideo && (
                              <IconButton
                                onClick={() => handleOlenViewMedia(index)}
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  color: "#fff",
                                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                                  },
                                  borderRadius: "50%",
                                }}
                              >
                                <PlayArrowIcon fontSize="large" />
                              </IconButton>
                            )}
                          </Box>
                        );
                      })}
                  </Box>
                </Box>
              )}
            </Box>
            <Box
              position={"fixed"}
              bottom={"32px"}
              left={"50%"}
              zIndex={50}
              gap={1}
              width={"100%"}
              maxWidth={"400px"}
              p={"0 16px"}
              sx={{ ...sxRowCenterBetween, transform: "translate(-50%, 0)" }}
            >
              <Button
                variant="contained"
                fullWidth
                component={Link}
                to={`/travel/${guideId}/create?step=1`}
                sx={{
                  ...sxText1440020,
                  height: "56px",
                  backgroundColor: "rgba(3, 132, 68, 1)",
                  color: "#fff",
                  borderRadius: "45px",
                  border: "1px solid rgba(3, 132, 68, 1)",
                  "&:hover": {
                    backgroundColor: "#fff",
                    color: DARCKCOLOR,
                  },
                }}
              >
                Book Guide
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </PageContainer>
  );
}

export default GuideView;
